import React, { useEffect, useState } from "react";
import styles from "../../../Pages/CreateAccount/CreateAccount.module.scss";
import ErrorLabel from "../../../Components/Atoms/ErrorLabel/ErrorLabel";
import { useFormik } from "formik";
import * as Yup from "yup";
import { PrimaryButton } from "../../../Components/Atoms/Button/Button";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { set_password, admin_update_password, user_update_password } from "../../../Enums/api_constunts";
import { postMethod } from "../../../Helpers/services";
import _ from "lodash";
import { showToast } from "../../../Components/Atoms/ToastNotifier/ToastNotifier";
import { Modal, Button, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";

export default function ProfileInfo({ openUpdatePassword = true, SetOpenUpdatePassword }) {
  
  const userData = useSelector((state) => state.auth.user);
  const [isSpinner, setIsSpinner] = useState(false);
  const [showModal, SetShowModal] = useState(openUpdatePassword == 2);
  const location = useLocation();
  
  return (
    <Modal show={showModal} onHide={() => { SetOpenUpdatePassword(0) }} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Profile Information</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <div className="row justify-content-center">
            <div className="col-md-10">
              {/* User First Name */}
              <div className="mb-3">
                <div className="form-group d-flex align-items-center">
                  <label className="form-label" style={{ width: "150px" }}>First Name:</label>
                  <div className="form-value">{userData.first_name}</div>
                </div>
              </div>

              {/* User Last Name */}
              <div className="mb-3">
                <div className="form-group d-flex align-items-center">
                  <label className="form-label" style={{ width: "150px" }}>Last Name:</label>
                  <div className="form-value">{userData.last_name}</div>
                </div>
              </div>

              {/* User Email */}
              <div className="mb-3">
                <div className="form-group d-flex align-items-center">
                  <label className="form-label" style={{ width: "150px" }}>Email:</label>
                  <div className="form-value">{userData.email}</div>
                </div>
              </div>

              {/* User Phone Number */}
              <div className="mb-3">
                <div className="form-group d-flex align-items-center">
                  <label className="form-label" style={{ width: "150px" }}>Phone Number:</label>
                  <div className="form-value">{userData.mobile_no}</div>
                </div>
              </div>

              {/* User Role */}
              {
                _.get(userData, "role_details.name") && (
                  <div className="mb-3">
                    <div className="form-group d-flex align-items-center">
                      <label className="form-label" style={{ width: "150px" }}>Role:</label>
                      <div className="form-value">{_.get(userData, "role_details.name")}</div>
                    </div>
                  </div>
                )
              }
              
            </div>
          </div>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => { SetOpenUpdatePassword(0) }}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
